import { useQuery } from "@oysterhr/core"
import { gql } from "@apollo/client"
import { IntegrationOnboardingDetailsQueryVariables } from "../gql/graphql"

export const GET_INTEGRATION_ONBOARDING_DETAILS = gql(`
  query IntegrationOnboardingDetails($companyId: ID!, $engagementId: ID!) {
    hrisIntegration(companyId: $companyId) {
      id
      platformName
      metadata
      onboardingTemplates {
        remoteId
        name
        type
      }
    }
    engagement(engagementId: $engagementId) {
      teamMemberName
      countryCode
    }
  }
`)

export const useIntegrationOnboardingDetails = ({
  companyId,
  engagementId,
}: IntegrationOnboardingDetailsQueryVariables) =>
  useQuery(GET_INTEGRATION_ONBOARDING_DETAILS, {
    variables: { companyId, engagementId },
    skip: !companyId || !engagementId,
  })
